import { render } from "./MyHeader.vue?vue&type=template&id=1579ef2b&scoped=true&ts=true"
import script from "./MyHeader.vue?vue&type=script&lang=ts"
export * from "./MyHeader.vue?vue&type=script&lang=ts"

import "./MyHeader.vue?vue&type=style&index=0&id=1579ef2b&scoped=true&lang=less"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1579ef2b"]])

export default __exports__